module.exports = __webpack_public_path__ + "static/media/sarangi.3ec30bc1.ogg";